const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const serviceWorkerUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      validateServiceWorker(serviceWorkerUrl);
      return;
    }

    register(serviceWorkerUrl);
  });
}

function register(serviceWorkerUrl) {
  navigator.serviceWorker.register(serviceWorkerUrl).then((registration) => {
    registration.update().catch(() => {
      // A failed update check should not prevent the currently installed app from running.
    });
  }).catch((error) => {
    console.error('AzTires service worker registration failed:', error);
  });
}

function validateServiceWorker(serviceWorkerUrl) {
  fetch(serviceWorkerUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');

      if (response.status === 404 || (contentType && !contentType.includes('javascript'))) {
        navigator.serviceWorker.ready
          .then((registration) => registration.unregister())
          .then(() => window.location.reload());
        return;
      }

      register(serviceWorkerUrl);
    })
    .catch(() => {
      // Keep an already-installed local service worker available while offline.
    });
}
